import { FormulaFieldRow } from './';
import { getRowKey } from '../';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { PeriscopeSfFormulaField, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback } from 'react';
import { useApiResource, useSelectionTable } from '@hooks';

export interface FormulaFieldSelectionTableProps {
	parentIndex: number;
	resourceIdsUri: string;
	uri: string;
}

export const FormulaFieldSelectionTable: React.FC<FormulaFieldSelectionTableProps> = ({
	parentIndex,
	resourceIdsUri,
	uri
}) => {
	const { resource, loading } = useApiResource<PeriscopeSfFormulaField[]>(uri);
	const selectionData = useSelectionTable({
		getRowKey,
		resourceIdsUri,
		results: resource,
		selectionType: SonarObjectType.SalesforceField
	});

	const renderRow = useCallback(
		(item: PeriscopeSfFormulaField) =>
			<FormulaFieldRow
				formulaField={ item }
				key={ item.sonarObjectId }
				parentIndex={ parentIndex } />
		,
		[ parentIndex ]
	);

	return (
		<SelectionTable
			dataSource={ resource }
			loading={ loading }
			renderRow={ renderRow }
			rowKey={ getRowKey }
			selectionData={ selectionData }
			selectionType={ PERISCOPE_TAB_TYPES.FORMULA_FIELDS } />
	);
};
